require("./brokerConvenienceTestAccordionHeader.scss");
// @ commons
const OKPillSelectors = require("components/commons/OKPillSelectors/OKPillSelectors");
const {
    OKCollapsingToggler,
} = require("commonsComponents/OKCollapsingToggler");
const { OKLink } = require("commonsComponents/OKLink");
// @vendor
const PropTypes = require("prop-types");
const React = require("react");
const classnames = require("classnames");

class BrokerConvenienceTestAccordionHeader extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(newValue) {
        const { selectAccordionButton, questionId, sectionId } = this.props;
        selectAccordionButton(sectionId, questionId, newValue);
    }

    handleClick() {
        const { disabled } = this.props;
        if (!disabled) {
            this.props.onAccordionClick(this.props.id);
        }
    }

    render() {
        const { pillsConfig, description, isExpanded, icon, togglerText } =
            this.props;

        const items = pillsConfig.map((item) => ({
            text: item.get("description").replace("shortResponse", ""),
            value: item.get("id"),
            selected: item.get("selected"),
        }));

        const selectedValues = items.map(({selected, value})=> {
            if (selected === "S") return value
        })

        const currentClassname = classnames("br-accordion-header", {
            "br-accordion-header--is-expanded": isExpanded,
        });

        const togglerClass = classnames(
            "br-accordion-header__columns__title--toggler",
            {
                "br-accordion-header__columns__title--toggler-hidden":
                    isExpanded,
            }
        );

        const iconClass = `br-accordion-header__icon ${icon}`;
        return (
            <div className={currentClassname}>
                <div className="br-accordion-header__content">
                    <div className="br-accordion-header__columns__icon">
                        <i className={iconClass} />
                    </div>
                    <div className="br-accordion-header__columns__title">
                        <div className="br-accordion-header__columns__title--text">
                            {description}
                        </div>
                        <div
                            className={togglerClass}
                            onClick={this.handleClick}
                        >
                            <OKLink modifier="emphasize">{togglerText}</OKLink>
                            <OKCollapsingToggler
                                isIconSecondary={true}
                                isIconFixed={true}
                                isExpanded={false}
                            />
                        </div>
                    </div>

                    <div className="br-accordion-header__columns__pills">
                        <OKPillSelectors
                            items={items}
                            onSelectionChange={this.handleChange}
                            selectedValues={selectedValues}
                            externalHandling
                        />
                    </div>
                </div>
            </div>
        );
    }
}

BrokerConvenienceTestAccordionHeader.propTypes = {
    buttons: PropTypes.array.isRequired,
    disabled: PropTypes.bool,
    expandAccordionRow: PropTypes.func.isRequired,
    icon: PropTypes.string,
    id: PropTypes.string.isRequired,
    isExpanded: PropTypes.bool,
    description: PropTypes.string,
    selectedOption: PropTypes.string,
    sectionId: PropTypes.string.isRequired,
    selectAccordionButton: PropTypes.func.isRequired,
    questionId: PropTypes.string.isRequired,
    togglerText: PropTypes.string.isRequired,
};

module.exports = BrokerConvenienceTestAccordionHeader;
